import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { OrdersKanban } from "@/components/admin/OrdersKanban";

export const Route = createFileRoute("/_authenticated/admin/")({
  head: () => ({
    meta: [
      { title: "Админ — Табло на поръчките | FIXHEN" },
      { name: "description", content: "Табло на FIXHEN и Wix поръчките по етапи на обработка." },
      { property: "og:title", content: "Табло на поръчките | FIXHEN" },
      { property: "og:description", content: "Платени, стартирани и изпратени поръчки във FIXHEN." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <AdminLayout>
      <OrdersKanban />
    </AdminLayout>
  ),
});